import { render, staticRenderFns } from "./qa2.vue?vue&type=template&id=95571760&"
import script from "./qa2.vue?vue&type=script&lang=js&"
export * from "./qa2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/nsdua/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95571760')) {
      api.createRecord('95571760', component.options)
    } else {
      api.reload('95571760', component.options)
    }
    module.hot.accept("./qa2.vue?vue&type=template&id=95571760&", function () {
      api.rerender('95571760', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/page/_home/qa2.vue"
export default component.exports